import { useMemo } from 'react';

export function usePortfolioInsights(investments) {
  return useMemo(() => {
    if (!investments || investments.length === 0) return null;
    const withReturns = investments.filter(inv => inv.current_value && inv.amount && inv.current_value !== inv.amount);
    const topPerformer = withReturns.reduce((best, inv) => {
      const ret = ((inv.current_value - inv.amount) / inv.amount) * 100;
      return (!best || ret > ((best.current_value - best.amount) / best.amount) * 100) ? inv : best;
    }, null);
    const worstPerformer = withReturns.reduce((worst, inv) => {
      const ret = ((inv.current_value - inv.amount) / inv.amount) * 100;
      return (!worst || ret < ((worst.current_value - worst.amount) / worst.amount) * 100) ? inv : worst;
    }, null);
    const uniqueTypes = new Set(investments.map(inv => inv.type)).size;
    const diversificationScore = Math.min(100, Math.round((uniqueTypes / 11) * 100));
    const avgReturn = withReturns.length > 0 ? withReturns.reduce((sum, inv) => sum + ((inv.current_value - inv.amount) / inv.amount) * 100, 0) / withReturns.length : 0;
    const volatile = investments.filter(inv => ['crypto', 'quoted_stocks', 'private_equity'].includes(inv.type)).length;
    const stable = investments.filter(inv => ['bank_balance', 'fixed_deposit', 'government_bond'].includes(inv.type)).length;
    const riskLevel = volatile > stable ? 'High' : stable > volatile ? 'Low' : 'Moderate';
    return { topPerformer, worstPerformer, diversificationScore, avgReturn, riskLevel, totalInvestments: investments.length, profitableCount: withReturns.filter(inv => inv.current_value > inv.amount).length, losingCount: withReturns.filter(inv => inv.current_value < inv.amount).length };
  }, [investments]);
}

export const formatInsightCurrency = (amount, currency = 'USD') => {
  try { return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount); }
  catch (e) { return `${currency} ${new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount)}`; }
};

export const formatInsightPercent = (value) => `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`;
